// PublicChatWidget.tsx - Wersja publiczna czatbota do embedowania
import React, { useEffect, useState } from 'react';
import { ChatWidget } from '../components/ChatWidget';

interface PublicChatWidgetProps {
  websiteId?: string;
  position?: 'bottom-right' | 'bottom-left';
  primaryColor?: string;
  title?: string;
  welcomeMessage?: string;
}

export const PublicChatWidget: React.FC<PublicChatWidgetProps> = ({
  websiteId = 'default',
  position = 'bottom-right',
  primaryColor = '#3B82F6',
  title = 'Potrzebujesz pomocy?',
  welcomeMessage = 'Cześć! 👋 Jak mogę Ci pomóc?'
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Zapisz konfigurację w localStorage dla tracking
    localStorage.setItem('plexi_chat_config', JSON.stringify({
      websiteId,
      source: 'website',
      timestamp: new Date().toISOString()
    }));
    
    setIsLoaded(true);
  }, [websiteId]);

  if (!isLoaded) return null;

  return (
    <div 
      className={`fixed z-50 ${
        position === 'bottom-right' ? 'bottom-4 right-4' : 'bottom-4 left-4'
      }`}
      style={{ '--chat-primary-color': primaryColor } as any}
    >
      <ChatWidget 
        title={title}
        welcomeMessage={welcomeMessage}
        source="website"
      />
    </div>
  );
};